import React, { useCallback, useState } from "react";
import { getHomeroomClassDisplayString } from "../../../../utils/utils";
import targetGroupType from "../../../../enums/targetGroupType";
import iconsList from "../../../ui/icons/iconsList";
import TabMenu, { Tab } from "../../../ui/tabMenu/TabMenu";
import ScheduleTabContent from "../scheduleTabContent/ScheduleTabContent";
import ScheduleTabContentPrivate from "../scheduleTabContent/ScheduleTabContentPrivate";
import classes from "./ScheduleEditBody.module.css";

const ScheduleEditBody = ({ texts = {}, mainClasses = [], scheduleEntities = [], onClose }) => {

    const [selectedTabKey, setSelectedTabKey] = useState(targetGroupType.Private);
    const [scheduleFileByTab, setScheduleFileByTab] = useState({});

    const handleScheduleFileChange = useCallback((tabKey, file) => {
        setScheduleFileByTab((prev) => {
            if (file === undefined) {
                const { [tabKey]: removed, ...rest } = prev;
                return rest;
            }
            return { ...prev, [tabKey]: file };
        });
    }, []);

    return (
        <div className={classes.EditBodyRoot}>
            {mainClasses.length > 0 ?
                <TabMenu activeTabKey={selectedTabKey} onTabChange={setSelectedTabKey}>
                    <Tab key={targetGroupType.Private} icon={iconsList.scheduleTabPersonal} tabKey={targetGroupType.Private} label={texts.schedulePopupTabPersonal}>
                        <ScheduleTabContentPrivate
                            scheduleEntities={scheduleEntities}
                            texts={texts}
                            scheduleFile={scheduleFileByTab[targetGroupType.Private]}
                            setScheduleFile={(file) => handleScheduleFileChange(targetGroupType.Private, file)}
                            onClose={onClose}
                        />
                    </Tab>
                    {mainClasses.map((mainClass) => (
                        <Tab key={mainClass.id} icon={iconsList.scheduleTabClass} tabKey={mainClass.id} label={getHomeroomClassDisplayString(mainClass, texts)}>
                            <ScheduleTabContent
                                tabKey={mainClass.id}
                                scheduleEntities={scheduleEntities}
                                texts={texts}
                                scheduleFile={scheduleFileByTab[mainClass.id]}
                                setScheduleFile={(file) => handleScheduleFileChange(mainClass.id, file)}
                                onClose={onClose}
                            />
                        </Tab>
                    ))}
                </TabMenu>
                :
                <ScheduleTabContentPrivate
                    scheduleEntities={scheduleEntities}
                    texts={texts}
                    scheduleFile={scheduleFileByTab[targetGroupType.Private]}
                    setScheduleFile={(file) => handleScheduleFileChange(targetGroupType.Private, file)}
                    onClose={onClose}
                />}
        </div>
    );
};
export default ScheduleEditBody;

